// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"FieldSet_fieldset__h6t6j","wrapper":"FieldSet_wrapper__3LIYf","label":"FieldSet_label__3Pp8w","error":"FieldSet_error__2w5JF"};